import { useEffect, useState } from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { Currency } from '../../backend'

import useGeolocation from './useGeolocation'

interface State {
  storageCurrency: Currency | null
  set(payload: { storageCurrency: Currency }): void
}

export const useStoreBase = create(
  persist<State>(
    set => ({
      storageCurrency: null,

      set,
    }),
    { name: 'selectedCurrency' },
  ),
)

export const useSelectedCurrency = () => {
  const location = useGeolocation()
  const { storageCurrency, set } = useStoreBase()

  const [currency, setCurrency] = useState<Currency>('EUR')

  useEffect(() => {
    if (storageCurrency) {
      setCurrency(storageCurrency)
    }
  }, [])

  useEffect(() => {
    // Init null currency to default, based on geo location
    if (storageCurrency === null && location) {
      const locationDefault: Currency =
        location === 'GB'
          ? ('GBP' as const)
          : location === 'US'
            ? ('USD' as const)
            : ('EUR' as const)

      set({ storageCurrency: locationDefault })
    }
  }, [location, storageCurrency, set])

  useEffect(() => {
    if (storageCurrency) {
      setCurrency(storageCurrency)
    }
  }, [storageCurrency])

  return {
    currency,
    setCurrency: (c: Currency) => set({ storageCurrency: c }),
  }
}
